// ============================================================================
// COMPONENTES DE CARD/KPI
// ============================================================================

import React from 'react';
import { COLORS } from './constants';

interface IndicatorCardProps {
  label: string;
  value: string | number;
  unit?: string;
  subtext?: string;
  icon: React.ComponentType<any>;
  color: string;
  trend?: 'good' | 'bad';
}

export const IndicatorCard = ({ label, value, unit, subtext, icon: Icon, color, trend }: IndicatorCardProps) => (
  <div className="bg-slate-50 dark:bg-slate-800/50 p-4 rounded-md shadow-sm hover:shadow transition-all relative overflow-hidden">
    <div className="flex justify-between items-start mb-2">
      <div className="p-2 rounded" style={{ backgroundColor: `${color}1A` }}>
        <Icon size={18} style={{ color }} />
      </div>
      {trend && (
        <span className={`text-[10px] font-semibold px-1.5 py-0.5 rounded ${trend === 'good' ? 'bg-emerald-50 text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-300' : 'bg-rose-50 text-rose-700 dark:bg-rose-950/40 dark:text-rose-300'}`}>
          {trend === 'good' ? '▲' : '▼'}
        </span>
      )}
    </div>
    <div>
      <div className="text-xs font-semibold text-slate-600 dark:text-slate-300">{label}</div>
      <div className="flex items-baseline gap-1 my-1">
        <span className="text-2xl font-medium text-slate-800 dark:text-slate-100 font-mono tracking-tight">{value}</span>
        {unit && <span className="text-xs font-medium text-slate-500 dark:text-slate-400">{unit}</span>}
      </div>
      {subtext && <div className="text-[10px] text-slate-500 dark:text-slate-400 mt-1">{subtext}</div>}
    </div>
  </div>
);

interface KPICardCompactProps {
  label: string;
  value: string | number;
  unit?: string;
  icon?: React.ComponentType<any>;
  color?: string;
}

export const KPICardCompact = ({ label, value, unit, icon: Icon, color = COLORS.blueKPI }: KPICardCompactProps) => (
  <div className="bg-slate-50 dark:bg-slate-800/50 p-3 rounded-md shadow-sm hover:shadow transition-all">
    <div className="flex gap-2 items-center">
      {Icon && <Icon size={14} style={{ color }} />}
      <div className="text-xs font-semibold text-slate-600 dark:text-slate-300">{label}</div>
    </div>
    <div className="flex items-baseline gap-1 mt-1">
      <span className="text-lg font-medium text-slate-800 dark:text-slate-100 font-mono">{value}</span>
      {unit && <span className="text-[10px] font-medium text-slate-500 dark:text-slate-400">{unit}</span>}
    </div>
  </div>
);
